import { render, staticRenderFns } from "./ContactInformationV2.vue?vue&type=template&id=54ba676b&scoped=true&lang=pug"
import script from "./ContactInformationV2.vue?vue&type=script&lang=js"
export * from "./ContactInformationV2.vue?vue&type=script&lang=js"
import style0 from "./ContactInformationV2.vue?vue&type=style&index=0&id=54ba676b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ba676b",
  null
  
)

export default component.exports